import { namespaceConfig } from 'fast-redux'

type ToastState = {
  toast_info: any
}

const DEFAULT_STATE: ToastState = {
    toast_info: {}
}

const { action, getState } = namespaceConfig('live_admin', DEFAULT_STATE)
const getStoreState = (state: ToastState): ToastState=> getState(state)


export const getToastInfo = (state: ToastState) => getStoreState(state)?.toast_info

export const setToastInfo = action('setToastInfo', function (state: ToastState, toast_info: any) {
    return { ...state, toast_info: {...toast_info} }
})